// @flow
import {useQuery} from '@tanstack/react-query';
import type {UseQueryReturn} from '@tanstack/react-query';
import {membersCountsRetrieve} from 'api/v2';
import type {MembersCounts, MembersCountsRetrieveParams} from 'api/v2';

export const useMembersCounts = (
  params?: MembersCountsRetrieveParams,
): UseQueryReturn<MembersCounts, any> => {
  const query = useQuery({
    queryKey: ['membersCounts', params],
    queryFn: () => membersCountsRetrieve(params),
    select: (response) => response.data,
  });

  return query;
};
